import React from 'react';
import { useAppContext } from 'src/components/app-context';
import { usePriceRowContext } from '../../../../price-row-context';
import { H4Text } from '@prisjakt/ui/text/variants';
import { trackMembershipReadMoreClicked } from './tracking';
import { MembershipInfoText, MembershipLink, InfoLinkWrapper } from './styles';
import { IconOutgoingLink } from '@prisjakt/ui/icon/outgoing-link';

export const MembershipInfo = () => {
  const { offer, product } = usePriceRowContext();
  const { t } = useAppContext();

  const hasMemberPriceOffer =
    offer.offerPrices?.memberPrice ||
    offer.alternativePrices
      ?.map(alt => alt?.offerPrices?.memberPrice)
      .some(isTrue => isTrue);

  if (!hasMemberPriceOffer) {
    return null;
  }

  const isFree = !offer.membershipProgram?.requiresCompensation;
  const name =
    offer.membershipProgram?.name || t('product', 'promotions.membership');

  const readMore = t('product', 'transparency.read-more');
  const membershipText = isFree
    ? t('product', 'promotions.membership-name-price-info-free', {
        name,
      })
    : t('product', 'promotions.membership-name-price-info', {
        name,
      });

  return (
    <div>
      <H4Text>{t('product', 'promotions.membership')}</H4Text>
      <InfoLinkWrapper>
        <MembershipInfoText>{membershipText}</MembershipInfoText>
        {offer.store?.id && (
          <MembershipLink
            to={`/redirect.php?ftgid=${offer.store?.id}&page_type=membership`}
            target="_blank"
            aria-label={readMore}
            data-test="MembershipLink"
            tabIndex={0}
            onClick={() =>
              trackMembershipReadMoreClicked(
                offer.membershipProgram?.name || '',
                offer.membershipProgram?.url || '',
                product.id
              )
            }
          >
            {readMore}
            <IconOutgoingLink />
          </MembershipLink>
        )}
      </InfoLinkWrapper>
    </div>
  );
};
